import { render, staticRenderFns } from "./DocumentsDetailCard.vue?vue&type=template&id=454592f0&scoped=true"
import script from "./DocumentsDetailCard.vue?vue&type=script&lang=js"
export * from "./DocumentsDetailCard.vue?vue&type=script&lang=js"
import style0 from "./DocumentsDetailCard.vue?vue&type=style&index=0&id=454592f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454592f0",
  null
  
)

export default component.exports